module.exports = __webpack_public_path__ + "img/login.dada52cb.png";